/**
 * 🔴 Carrera envío-vs-captura (4.º intento, dato decisivo de Arturo: capturó
 * todo, UN clic, se fue uno). Cada platillo se persiste con su PROPIA petición
 * (~350 ms en staging). "Enviar a cocina" disparaba /fire antes de que las
 * capturas en vuelo estuvieran confirmadas → el servidor solo tenía 1 renglón
 * y sellaba ese uno. El `busy` booleano no bastaba: se apaga al resolver la
 * PRIMERA captura y re-habilita "Enviar" con las demás aún en vuelo.
 *
 * CaptureTracker: cuenta las capturas EN VUELO y ofrece una barrera
 * (`whenIdle`) que resuelve cuando TODAS se confirmaron. "Enviar a cocina"
 * espera esa barrera antes de /fire; el botón muestra "Guardando…" mientras
 * `pending() > 0` (el mesero VE por qué espera — nada de deshabilitar en silencio).
 */
export class CaptureTracker {
  private inFlight = new Set<Promise<unknown>>();
  private listeners = new Set<() => void>();

  /** Registra una captura en vuelo. Devuelve la misma promesa (para encadenar). */
  track<T>(p: Promise<T>): Promise<T> {
    this.inFlight.add(p);
    this.emit();
    const done = () => { this.inFlight.delete(p); this.emit(); };
    p.then(done, done);
    return p;
  }

  /** # de capturas sin confirmar. El botón de enviar muestra "Guardando…" si > 0. */
  pending(): number {
    return this.inFlight.size;
  }

  /**
   * Barrera: resuelve cuando NO quedan capturas en vuelo. Reentrante — si
   * mientras esperaba entraron más (el mesero siguió capturando), las espera
   * también, hasta drenar del todo. Nunca rechaza (usa allSettled).
   */
  async whenIdle(): Promise<void> {
    while (this.inFlight.size > 0) {
      await Promise.allSettled([...this.inFlight]);
    }
  }

  /** Suscripción para re-renderizar el contador (React). */
  subscribe(fn: () => void): () => void {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }
  private emit() { this.listeners.forEach((fn) => { try { fn(); } catch { /* noop */ } }); }
}
